import * as Sentry from "@sentry/browser";
import * as React from "react";
import { Editor, NodeEntry, Range } from "slate";
import { RenderElementProps, RenderLeafProps } from "slate-react";

export type ReactPart = Partial<{
  onKeyDown: (
    event: React.KeyboardEvent<HTMLDivElement>,
    editor: Editor,
    next: (event: React.KeyboardEvent<HTMLDivElement>) => void
  ) => void;
  decorate: (entry: NodeEntry, editor: Editor, next: (entry: NodeEntry) => Range[]) => Range[];
  onDOMBeforeInput: (event: Event, editor: Editor, next: (event: Event) => void) => void;
  renderElement: (
    props: RenderElementProps,
    editor: Editor,
    next: (props: RenderElementProps) => JSX.Element
  ) => JSX.Element;
  renderLeaf: (props: RenderLeafProps, editor: Editor, next: (props: RenderLeafProps) => JSX.Element) => JSX.Element;
}>;

export function withErrorContext(fn: (editor: Editor) => Editor): (editor: Editor) => Editor {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const wrappedFn = (editor: Editor) => {
    const sentryHub = Sentry.getCurrentHub();
    const scope = sentryHub.pushScope();
    scope.setExtra(
      "editorPayload",
      JSON.stringify({
        value: editor.children,
        selection: editor.selection,
        history: editor.history,
      })
    );

    try {
      return fn(editor);
    } finally {
      sentryHub.popScope();
    }
  };

  return wrappedFn;
}

export type PluginSpec = [(editor: Editor) => Editor, ReactPart];
